export const minimumSubtaskVolume = 1
export const maximumSubtaskVolume = 99

export function normalizeSubtaskVolume(value: unknown) {
  const parsed = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(parsed)) return minimumSubtaskVolume
  return Math.min(maximumSubtaskVolume, Math.max(minimumSubtaskVolume, Math.round(parsed)))
}
